<div class="inbox-message-list">
  <div
    class="inbox-message"
    *ngFor="let message of messages"
    [ngClass]="{
      'inbox-message--active': message.id === activeMessage?.id && !isManage,
      'inbox-message--inactive': isManage
    }"
    (click)="showMessage(message.id)"
  >
    <div class="inbox-message__status">
      <i class="icon icon-ui-bubble" *ngIf="!message.isRead"></i>
    </div>
    <div class="inbox-message__content">
      <div class="inbox-message__header">
        <span class="inbox-message__title">{{ message.subject }}</span>
        <span class="inbox-message__date">{{ message.date | date: "dd-MM-yyyy" }}</span>
      </div>
      <div class="inbox-message__summary">{{ message.summary }}</div>
    </div>
    <i class="icon icon-ui-arrow--right--sm inbox-message__arrow" *ngIf="!isManage"></i>
    <button
      class="button button--secondary button--destructive inbox-message__trash"
      *ngIf="isManage"
      (click)="deleteMessage(message.id)"
      [attr.aria-label]="'inbox.label.remove' | translate"
    >
      <i class="icon icon-ui-trash"></i>
    </button>
  </div>
  <div class="inbox-message-list__actions">
    <button class="button button--tertiary" *ngIf="!isManage" (click)="toggleIsManage($event)">
      {{ "inbox.label.manage_messages" | translate }}
    </button>
    <button class="button" *ngIf="isManage" (click)="toggleIsManage($event)">
      {{ "inbox.label.manage_messages_done" | translate }}
    </button>
  </div>
</div>
